(function () {
  'use strict';

  function init() {
    var form = document.getElementById('b2b-contact-form');
    if (!form) return;

    var nameInput = form.querySelector('#b2b-name');
    var companyInput = form.querySelector('#b2b-company');
    var nipInput = form.querySelector('#b2b-nip');
    var phoneInput = form.querySelector('#b2b-phone');
    var emailInput = form.querySelector('#b2b-email');
    var typesHidden = form.querySelector('[data-types-hidden]');
    var typeCheckboxes = form.querySelectorAll('[data-business-type]');
    var rodoCheckbox = form.querySelector('[data-required-consent]');
    var submitBtn = form.querySelector('.b2b-form__submit');
    var honeypot = form.querySelector('input[name="contact[website_url]"]');

    function setError(fieldId, message) {
      var errorEl = form.querySelector('[data-error-for="' + fieldId + '"]');
      var input = form.querySelector('#' + fieldId);
      if (errorEl) {
        errorEl.textContent = message || '';
        if (message) {
          errorEl.classList.add('is-visible');
        } else {
          errorEl.classList.remove('is-visible');
        }
      }
      if (input) {
        if (message) {
          input.classList.add('b2b-form__input--error');
        } else {
          input.classList.remove('b2b-form__input--error');
        }
      }
    }

    function setGroupError(key, message) {
      var errorEl = form.querySelector('[data-error-for="' + key + '"]');
      if (errorEl) {
        errorEl.textContent = message || '';
        if (message) {
          errorEl.classList.add('is-visible');
        } else {
          errorEl.classList.remove('is-visible');
        }
      }
    }

    function validateNIP(nip) {
      var clean = String(nip).replace(/[\s-]/g, '');
      if (!/^\d{10}$/.test(clean)) return false;
      var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      var sum = 0;
      for (var i = 0; i < 9; i++) {
        sum += parseInt(clean.charAt(i), 10) * weights[i];
      }
      var checksum = sum % 11;
      if (checksum === 10) return false;
      return checksum === parseInt(clean.charAt(9), 10);
    }

    function validatePhone(phone) {
      var clean = String(phone).replace(/[\s\-()]/g, '');
      return /^(\+48)?\d{9}$/.test(clean);
    }

    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(email).trim());
    }

    function getCheckedTypes() {
      var values = [];
      for (var i = 0; i < typeCheckboxes.length; i++) {
        if (typeCheckboxes[i].checked) {
          values.push(typeCheckboxes[i].value);
        }
      }
      return values;
    }

    if (nipInput) {
      nipInput.addEventListener('blur', function () {
        var val = nipInput.value.trim();
        if (val.length > 0 && !validateNIP(val)) {
          setError('b2b-nip', 'Wpisz poprawny 10-cyfrowy numer NIP.');
        } else {
          setError('b2b-nip', '');
        }
      });

      nipInput.addEventListener('input', function () {
        nipInput.value = nipInput.value.replace(/\D/g, '').slice(0, 10);
        if (nipInput.classList.contains('b2b-form__input--error')) {
          setError('b2b-nip', '');
        }
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('blur', function () {
        var val = phoneInput.value.trim();
        if (val.length > 0 && !validatePhone(val)) {
          setError('b2b-phone', 'Wpisz poprawny numer telefonu (9 cyfr lub +48).');
        } else {
          setError('b2b-phone', '');
        }
      });

      phoneInput.addEventListener('input', function () {
        if (phoneInput.classList.contains('b2b-form__input--error')) {
          setError('b2b-phone', '');
        }
      });
    }

    if (emailInput) {
      emailInput.addEventListener('blur', function () {
        var val = emailInput.value.trim();
        if (val.length > 0 && !validateEmail(val)) {
          setError('b2b-email', 'Wpisz poprawny adres email.');
        } else {
          setError('b2b-email', '');
        }
      });
    }

    for (var i = 0; i < typeCheckboxes.length; i++) {
      typeCheckboxes[i].addEventListener('change', function () {
        if (getCheckedTypes().length > 0) {
          setGroupError('types', '');
        }
      });
    }

    form.addEventListener('submit', function (e) {
      if (honeypot && honeypot.value.trim() !== '') {
        e.preventDefault();
        return;
      }

      var hasError = false;

      if (!nameInput.value.trim() || nameInput.value.trim().length < 2) {
        setError('b2b-name', 'Wpisz imię i nazwisko.');
        hasError = true;
      }

      if (!companyInput.value.trim() || companyInput.value.trim().length < 2) {
        setError('b2b-company', 'Wpisz nazwę firmy.');
        hasError = true;
      }

      if (!validateNIP(nipInput.value)) {
        setError('b2b-nip', 'Wpisz poprawny 10-cyfrowy numer NIP.');
        hasError = true;
      }

      if (!validatePhone(phoneInput.value)) {
        setError('b2b-phone', 'Wpisz poprawny numer telefonu (9 cyfr lub +48).');
        hasError = true;
      }

      if (!validateEmail(emailInput.value)) {
        setError('b2b-email', 'Wpisz poprawny adres email.');
        hasError = true;
      }

      var checkedTypes = getCheckedTypes();
      if (checkedTypes.length === 0) {
        setGroupError('types', 'Wybierz przynajmniej jedną opcję.');
        hasError = true;
      } else if (typesHidden) {
        typesHidden.value = checkedTypes.join(', ');
      }

      if (rodoCheckbox && !rodoCheckbox.checked) {
        setGroupError('rodo', 'Zgoda RODO jest wymagana, aby wysłać formularz.');
        hasError = true;
      } else {
        setGroupError('rodo', '');
      }

      if (hasError) {
        e.preventDefault();
        var firstError = form.querySelector('.is-visible, .b2b-form__input--error');
        if (firstError) {
          var target = firstError.closest('.b2b-form__field') || firstError;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
      }
    });

    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      var success = document.querySelector('.b2b-form__success');
      if (success) {
        setTimeout(function () {
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
          success.focus();
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
